import React, { useState, useEffect, useRef } from "react";
import Keysensor from "../components/Keysensor";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import backImage from "../images/type.jpeg";
import firebase, { db } from "../libs/firebase";

const Game = withRouter(props => {
  const intervalRef = useRef();
  const [entered, setEntered] = useState("");
  const [current, setCurrent] = useState("");
  const [unentered, setUnentered] = useState(``);
  const [score, setScore] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [scene, setScene] = useState("playing");
  const [results, setResults] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await Axios.get(
        "https://baconipsum.com/api/?type=meat-and-filler&paras=1&format=text"
      );

      // const initialSentence = response.data;
      const initialSentence = response.data;
      setUnentered(initialSentence);
      const nextChar = initialSentence.charAt(0);
      setCurrent(nextChar);
      setUnentered(initialSentence.slice(1));

      fetchResults();

      const docId = db.collection("play_log").doc().id;
      db.collection("play_log")
        .doc(docId)
        .set({
          docId: docId,
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        });

      const interval = setInterval(() => {
        setSeconds(seconds => seconds + 0.1);
      }, 100);
      intervalRef.current = interval;
      return () => clearInterval(interval);
    })();
  }, []);

  const handleKeyPress = e => {
    e.preventDefault();
    if (scene === "result") {
      if (e.charCode === 32) {
        props.history.push("/start");
      }
    }
    // const currentCode = current.toLowerCase().charCodeAt(0);
    const currentCode = current.charCodeAt(0);

    if (
      e.charCode === currentCode ||
      (e.charCode === 13 && currentCode === 10)
    ) {
      const nextChar = unentered.charAt(0);

      setScore(score + 1);
      setEntered(`${entered}${String.fromCharCode(currentCode)}`);
      setCurrent(nextChar);
      setUnentered(unentered.slice(1));

      if (unentered === "") {
        const docId = db.collection("results").doc().id;
        db.collection("results")
          .doc(docId)
          .set({
            docId: docId,
            time: seconds,
            score: score,
            average: average(score, seconds),
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          });

        clearInterval(intervalRef.current);
        setScene("result");
      }
    } else {
    }
  };

  const handlekeyDown = e => {
    if (e.keyCode === 27) {
      props.history.push("/");
    }
  };

  //entered: `${state.entered}${action.char}`, unentered: state.unentered.slice(1)

  const gameStyle = {
    backgroundColor: "#eeeeee",
    padding: "20px",
    boxShadow: "0 0 10px rgba(0,0,0,.2)",
    minHeight: "300px",
    fontSize: "1.3rem",
    lineHeight: "1.4",
    width: "600px",
    margin: "0 auto 50px",
    textAlign: "left",
    whiteSpace: "break-spaces",
    overflow: "wrap",
    fontFamily: "monospace, serif"
  };

  const currentString = value => {
    if (value === "\n") {
      return "↓\n";
    } else {
      return value;
    }
  };

  const average = (score, seconds) => {
    if (seconds === 0) {
      return 0;
    } else {
      return score / seconds;
    }
  };

  const resultStyle = {
    backgroundColor: "#eeeeee",
    padding: "20px",
    boxShadow: "0 0 10px rgba(0,0,0,.3)",
    width: "600px",
    margin: "0 auto 50px",
    textAlign: "left"
  };

  const mainStyle = {
    height: "calc(100vh - 50px - 50px)",
    textAlign: "center",
    backgroundImage: `url(${backImage}`,
    backgroundColor: "rgba(255,255,255,0.7)",
    backgroundBlendMode: "lighten",
    backgroundPosition: "bottom",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  };

  const fetchResults = async () => {
    const resultRef = db
      .collection("results")
      .orderBy("average", "desc")
      .limit(5);
    const snapshots = await resultRef.get();
    const docs = snapshots.docs.map(doc => doc.data());
    await setResults(docs);
  };

  const listStyle = {
    listStyle: "none"
  };

  const subTitleStyle = {
    padding: "10px 0 10px 10px",
    borderLeft: "5px solid #ffcccc",
    borderBottom: "1px solid grey",
    boxShadow: "0 0 2px rgba(0,0,0,.3)",
    color: "#333333"
  };

  return (
    <Keysensor onKeyPress={handleKeyPress} onKeyDown={handlekeyDown}>
      <div style={mainStyle}>
        <div style={gameStyle}>
          <span style={{ color: "gray" }}>{entered}</span>
          <span style={{ backgroundColor: "#cccc00" }}>
            {currentString(current)}
          </span>
          <span>{unentered}</span>
        </div>
        <div style={resultStyle}>
          <h4 style={subTitleStyle}>Score</h4>
          <div style={{ margin: "10px 0 30px 0" }}>
            <p>Time：{seconds.toFixed(1)}</p>
            <p>Hit：{score}</p>
            <p>Average：{average(score, seconds).toFixed(2)}</p>
          </div>
          <h4 style={subTitleStyle}>High Score</h4>
          <div style={{ margin: "10px 0 30px 0" }}>
            <ul style={listStyle}>
              {results.map(result => {
                return (
                  <li key={result.docId}>
                    {result.average.toFixed(2)} hit/sec
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </Keysensor>
  );
});

export default Game;
